import App from "./App";
import store from "./store/index";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";

import { ConfigProvider } from "antd";

// 兼容360浏览器
import {
  StyleProvider,
  legacyLogicalPropertiesTransformer,
} from "@ant-design/cssinjs";

import "dayjs/locale/zh-cn";
import locale from "antd/locale/zh_CN";
import { isMobiileFu } from "./utils/tool";
import AppM from "./AppM";

const container = document.getElementById("root") as HTMLElement;

const root = createRoot(container);

// console.log("----", isMobiileFu());

root.render(
  <ConfigProvider
    locale={locale}
    theme={{
      token: {
        colorPrimary: "#9f1927",
      },
    }}
  >
    <Provider store={store}>
      <StyleProvider
        hashPriority="high"
        transformers={[legacyLogicalPropertiesTransformer]}
      >
        {isMobiileFu() ? <AppM /> : <App />}
      </StyleProvider>
    </Provider>
  </ConfigProvider>
);
